import { Service } from './axios.js'


export function userLogin(data){
    return Service({
        url: '/login',
        mothod: 'post',
        data:data
    })
}

export function goodsList(data){
    return Service({
        url: '/goodsList',
        mothod: 'post',
        data:data
    })
}

export function goodsInfo(data){
    return Service({
        url: '/goodsInfo',
        mothod: 'post',
        data:data
    })
}

export function contractList(data){
    return Service({
        url: '/contractList',
        mothod: 'post',
        data:data
    })
}

export function contractInfo(data){
    return Service({
        url: '/contractInfo',
        mothod: 'post',
        data:data
    })
}